export const environment = {
  production: true,
  loginUrl: 'https://login.input4you.be/LoginAPI/',
  atelierController: 'https://atelierapi-testing.input4you.be/'
};
